import { createSelector } from 'reselect'

import { selectCompletenessState } from './selectCompletenessState'

export const selectLoadingStatus = createSelector(
  [selectCompletenessState],
  (state) => state.status
)
